<svelte:options tag={null} />

<script lang="ts">
  import type { ToggleSize } from './toggle.types';
  import { EventHandler } from '../../utilities/EventHandler';

  export let name: string;
  export let checked: boolean;
  export let disabled = false;
  export let size: ToggleSize = 'm';
  export let label: string;

  $: userClass = $$props.class;
  $: attributes = { ...$$restProps };
  $: delete attributes.class;

  let eventHandler = new EventHandler();

  function handleState(): void {
    checked = !checked;
    eventHandler.dispatch('change', checked);
  }
</script>

<div
  class="mc-toggle {!label ? ' mc-toggle--hide-label' : ''} {size === 's'
    ? ' mc-toggle--s'
    : ''} {userClass}"
  {...attributes}
>
  <input
    class="mc-toggle__input"
    id={name}
    {name}
    type="checkbox"
    {checked}
    {disabled}
    on:click={handleState}
  />
  <label class="mc-toggle__label" for={name}>
    {#if label}
      <span class="mc-toggle__content">{label}</span>
    {/if}
  </label>
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/c.toggle';
</style>
